import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '@environments/environment';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { MODULES_WITH_STATUS } from '@molecules/status-devices-card/status-devices-card.component';
import { ControlPageStore } from '@pages/control-page/control-page-store.service';
import { SUPPORTED_CONTROL_WEATHER_MODULES } from '@pages/control-page/control-page.const';
import { map } from 'rxjs';

@Component({
  selector: 'app-control-page-body',
  templateUrl: './control-page-body.component.html',
  styleUrls: ['./control-page-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlPageBodyComponent {

  datasets$ = this.controlPageStore.datasets$;

  displayForecast$ = this.modulesFacade.currentHomeModules$.pipe(
    map(modules => modules.find(mod => SUPPORTED_CONTROL_WEATHER_MODULES.includes(mod.type))),
  );
  hasStatusDevices$ = this.modulesFacade.currentHomeModules$.pipe(
    map(modules => modules.filter(module => MODULES_WITH_STATUS.includes(module.type)).length > 0),
  );

  environment = environment;

  constructor(
    private controlPageStore: ControlPageStore,
    private modulesFacade: ModulesFacade,
  ) { }

}
